import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "side-view",
			subItem: "contact-group-options",
			extraItem: data.id,
		});
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				padding: "10px",
				paddingTop: "20px",
				paddingBottom: "20px",
				borderBottom: "1px solid var(--secondaryColor)",
			}}
		>
			<h6
				style={{
					fontSize: "22px",
				}}
				className="font-semi-bold"
			>
				{data.name}
			</h6>
		</div>
	);
}
